import { RouteRecordRaw } from "vue-router"

// ====================================
// Module usage-profile
// ====================================
// Route profil utilisation (fiche bâtiment) : @core/router/building.routes.ts

export const routes = [] as RouteRecordRaw[]
